// src/auditoria/components/tx-simple-modal/tx-modal-confirmar-descarte.tsx
//
// Diálogo que aparece quando o usuário tenta sair de um modal com formulário
// preenchido. Fica dentro do `TxSimpleModal` (e não no `AlertProvider` genérico)
// por dois motivos: o texto precisa dizer o que se perde, e por ser montado
// depois do modal ele é sempre o diálogo do topo da pilha do MUI — ou seja, o
// ESC digitado aqui cancela o descarte em vez de vazar para o modal de baixo.

import {
  Dialog,
  Button,
  Typography,
  DialogTitle,
  DialogActions,
  DialogContent,
} from '@mui/material';

// ----------------------------------------------------------------------

type Props = {
  aberto: boolean;
  /** Volta para o formulário sem perder nada. */
  aoContinuar: () => void;
  /** Confirma a perda e fecha o modal. */
  aoDescartar: () => void;
};

const ID_TITULO = 'tx-modal-descarte-titulo';
const ID_TEXTO = 'tx-modal-descarte-texto';

export function TxModalConfirmarDescarte({ aberto, aoContinuar, aoDescartar }: Props) {
  return (
    <Dialog
      open={aberto}
      onClose={aoContinuar}
      maxWidth="xs"
      fullWidth
      aria-labelledby={ID_TITULO}
      aria-describedby={ID_TEXTO}
    >
      <DialogTitle id={ID_TITULO}>Descartar o que você preencheu?</DialogTitle>

      <DialogContent>
        <Typography id={ID_TEXTO} variant="body2">
          Este formulário tem informações digitadas que ainda não foram salvas. Se fechar agora,
          elas serão perdidas e será preciso preencher tudo de novo.
        </Typography>
      </DialogContent>

      <DialogActions>
        {/* O foco inicial vai na saída segura: quem fecha sem querer não perde
            o trabalho só por apertar Enter. */}
        <Button autoFocus variant="contained" color="inherit" onClick={aoContinuar}>
          Continuar preenchendo
        </Button>
        <Button color="error" onClick={aoDescartar}>
          Descartar e fechar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
